import R from 'ramda'

const MENTION_TRIGGER_TYPE = 'MENTION'
const MENTION_DISPLAY_TYPE = 'Match Handle'

const isMentionWidgetTrigger = R.propEq('type', MENTION_TRIGGER_TYPE)

const convertMentionWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(MENTION_DISPLAY_TYPE),
  handles: R.prop('data')
})

export { isMentionWidgetTrigger, convertMentionWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/instagram/widget-to-form/mention.js